module.exports = __webpack_public_path__ + "img/ico_like_active.9d3e2327.svg";